import { Box, Typography } from "@mui/material";
import logo from "src/assets/1house-tv-logo.png";

const Footer = () => {
  return (
    // <Box
    //   component="footer"
    //   sx={{
    //     bgcolor: "rgba(0,0,0,0.8)",
    //     backdropFilter: "blur(6px)",
    //     py: 1,
    //     px: { xs: 2, md: 4, lg: 6 },
    //     flexShrink: 0,
    //   }}
    // >
      <Box
        sx={{
          maxWidth: "100%",
          mx: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly",
          gap: 2,
          backgroundColor:"#0d0d0d",
          gap:30
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center",justifyContent: "space-evenly", gap: 1 }}>
          <Box
            component="img"
            src={logo}
            alt="1House TV"
            sx={{ height: { xs: 16, md: 38 }, width: "auto", objectFit: "contain" }}
          />
        </Box>
        <Typography
          variant="caption"
          sx={{ color: "rgba(255,255,255,0.6)", fontSize: { xs: "10px", md: "12px" } }}
        >
          (c) 2026 1House Global. All rights reserved.
        </Typography>
      </Box>
    // </Box>
  );
};

export default Footer;
